/**
 * Created by Vladislav on 20.03.2026.
 */

class PaddingComponent extends BaseComponent {
    onCreate() {
        this.padding = PrefabBuilder.resolveProperty(this.options, this.context) || {};
    }

    onAttach() {
        cleverapps.UI.wrapWithPadding(this.node, this.padding, true);
    }
}

Prefab.registerComponent("PaddingComponent", PaddingComponent);
